"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATEFORMAT = exports.EDUCATIONAL = exports.ROLES = exports.NANI_CLUB_REDIRECT_PATH = exports.LOGIN_PATH = exports.COOKIE_NANI_LOGIN_TOKEN_NAME = exports.COOKIE_LOGIN_TOKEN_NAME = void 0;

/** 平台 token：用 OneClub / Nani Club 的 JWT 跟 resource-platform 換來的 */
var COOKIE_LOGIN_TOKEN_NAME = "nani_oneclass_resource_platform_token";
/** 會員 JWT */

exports.COOKIE_LOGIN_TOKEN_NAME = COOKIE_LOGIN_TOKEN_NAME;
var COOKIE_NANI_LOGIN_TOKEN_NAME = "nani_oneclass_login_token";
exports.COOKIE_NANI_LOGIN_TOKEN_NAME = COOKIE_NANI_LOGIN_TOKEN_NAME;
var LOGIN_PATH = "/login";
exports.LOGIN_PATH = LOGIN_PATH;
var NANI_CLUB_REDIRECT_PATH = "/naniClubRedirect";
exports.NANI_CLUB_REDIRECT_PATH = NANI_CLUB_REDIRECT_PATH;
var ROLES = {
  Editor: "編輯",
  Guest: "訪客"
};
exports.ROLES = ROLES;
var EDUCATIONAL = [{
  name: "國小",
  value: "E"
}, {
  name: "國中",
  value: "J"
}, {
  name: "高中",
  value: "H"
}];
exports.EDUCATIONAL = EDUCATIONAL;
var DATEFORMAT = "YYYY-MM-DD";
exports.DATEFORMAT = DATEFORMAT;